var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass:
            "footer__text font-16 d-flex align-items-center sm-footer"
        },
        [
          _c(
            "div",
            [
              _c("span", [
                _vm._v("© Ocean Network Express Pte. Ltd. All rights reserved.")
              ]),
              _c("span", { staticClass: "ml-8 mr-8" }),
              _c(
                "router-link",
                {
                  staticClass: "underline",
                  attrs: {
                    to: "/" + _vm.countryCode + "/terms-of-use",
                    target: "_blank"
                  }
                },
                [_vm._v("Terms of Use")]
              ),
              _c("span", { staticClass: "ml-8 mr-8" }, [_vm._v(" - ")]),
              _c(
                "router-link",
                {
                  staticClass: "underline",
                  attrs: {
                    to: "/" + _vm.countryCode + "/user-guide",
                    target: "_blank"
                  }
                },
                [_vm._v("User Guide")]
              )
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }